import React, { useEffect, forwardRef, useImperativeHandle, useState, useRef } from "react";
// ------- amchart4
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import "./chartConfig.css";
let data = []
const ChartConfig = forwardRef((props, ref) => {
    let chart1 = useRef(0);
    let series1 = useRef(0);
    let colorArray = [];
    useImperativeHandle(ref, () => ({
        check(liveData) {
            if (liveData) {
                if (data.length > 9) {
                    chart1.current.addData(liveData, 1);
                } else {
                    data.push(liveData)
                    chart1.current.addData(liveData);
                }
                primaryColor();
            }
        }
    }))
    useEffect(() => {
        data = props?.data
        createChart();
        chart1.current.data = props.chart.axisX === "category" && !props?.data?.length ? [{ category: 'N/A' }] : props.data;
        primaryColor();
        return () => {
            chart1.current.dispose();
        }
    }, [])
    const createChart = () => {
        // Use theme
        // am4core.useTheme(am4themes_moonrisekingdom);
        if (!("animation" in props.chart) || props?.chart?.animation) {
            am4core.useTheme(am4themes_animated);
        }
        var interfaceColors = new am4core.InterfaceColorSet();

        // Create Chart
        let chart = am4core.create(props.chart.id, am4charts.XYChart); // here chart is the ID of a div

        // chart.zoomOutButton.disabled = true;

        let X_Axis = null;
        if (props.chart.axisX === "date") {
            chart.dateFormatter.dateFormat = "hh:mm:ss a | MMM dd yyyy";
            X_Axis = chart.xAxes.push(new am4charts.DateAxis());
            // X_Axis.renderer.minGridDistance = 80;
            X_Axis.startLocation = -0.3;
            X_Axis.endLocation = 1.5;
            X_Axis.dateFormats.setKey("millisecond", "hh:mm:ss a");
            X_Axis.periodChangeDateFormats.setKey("millisecond", "hh:mm:ss a");
            X_Axis.dateFormats.setKey("second", "hh:mm:ss a");
            X_Axis.periodChangeDateFormats.setKey("second", "hh:mm:ss a");
            X_Axis.dateFormats.setKey("minute", "hh:mm:ss a");
            X_Axis.periodChangeDateFormats.setKey("minute", "[bold]hh:mm a");
            X_Axis.dateFormats.setKey("hour", "hh:mm a");
            X_Axis.periodChangeDateFormats.setKey("hour", "[bold]hh:mm a | MMM dd yyyy[/]");
            X_Axis.dateFormats.setKey("day", "dd MMM yyyy");
            X_Axis.periodChangeDateFormats.setKey("day", "[bold]dd MMMM yyyy[/]");
            // X_Axis.dateFormats.setKey("week", "dd MMM yyyy");
            // X_Axis.periodChangeDateFormats.setKey("week","[bold]dd MMMM yyyy[/]");
            X_Axis.dateFormats.setKey("week", "W");
            X_Axis.periodChangeDateFormats.setKey("week", "W");
            // X_Axis.dateFormats.setKey("week", "'Week 'W");
            // X_Axis.periodChangeDateFormats.setKey("week", "'Week 'W");
            X_Axis.dateFormats.setKey("month", "MMM yyyy");
            X_Axis.periodChangeDateFormats.setKey("month", "[bold]MMMM yyyy[/]");
            X_Axis.gridIntervals.setAll([
                { timeUnit: "millisecond", count: 1 },
                { timeUnit: "millisecond", count: 5 },
                { timeUnit: "millisecond", count: 10 },
                { timeUnit: "millisecond", count: 50 },
                { timeUnit: "millisecond", count: 100 },
                { timeUnit: "millisecond", count: 500 },
                { timeUnit: "second", count: 1 },
                { timeUnit: "second", count: 5 },
                { timeUnit: "second", count: 10 },
                { timeUnit: "second", count: 30 },
                { timeUnit: "minute", count: 1 },
                { timeUnit: "minute", count: 5 },
                { timeUnit: "minute", count: 10 },
                { timeUnit: "minute", count: 15 },
                { timeUnit: "minute", count: 30 },
                { timeUnit: "hour", count: 1 },
                { timeUnit: "hour", count: 3 },
                { timeUnit: "hour", count: 6 },
                { timeUnit: "hour", count: 12 },
                { timeUnit: "day", count: 1 },
                // { timeUnit: "day", count: 2 },
                // { timeUnit: "day", count: 3 },
                // { timeUnit: "day", count: 4 },
                { timeUnit: "day", count: 5 },
                // { timeUnit: "week", count: 1 },
                { timeUnit: "month", count: 1 },
                { timeUnit: "month", count: 2 },
                { timeUnit: "month", count: 3 },
                { timeUnit: "month", count: 6 },
                { timeUnit: "year", count: 1 },
                { timeUnit: "year", count: 2 },
                { timeUnit: "year", count: 5 },
                { timeUnit: "year", count: 10 },
                { timeUnit: "year", count: 50 },
                { timeUnit: "year", count: 100 },
                { timeUnit: "year", count: 200 },
                { timeUnit: "year", count: 500 },
                { timeUnit: "year", count: 1000 },
                { timeUnit: "year", count: 2000 },
                { timeUnit: "year", count: 5000 },
                { timeUnit: "year", count: 10000 },
                { timeUnit: "year", count: 100000 }
            ]);
            if ("grid" in props.chart && (!props.chart.grid || props.chart.grid === "y")) {
                X_Axis.renderer.grid.template.stroke = "#00000000"
            }
            // X_Axis.dateFormats.setKey("day", "[bold]MMM dd[/]");
            // X_Axis.periodChangeDateFormats.setKey("day", "[bold]MMM yyyy[/]");
            // X_Axis.periodChangeDateFormats.setKey("day", "[bold]MMM yyyy[/]");
            X_Axis.renderer.inside = true;
        } else {
            X_Axis = chart.xAxes.push(new am4charts.CategoryAxis());
            X_Axis.dataFields.category = "category";
            // X_Axis.renderer.grid.template.location = 0;
            X_Axis.renderer.minGridDistance = 1;
            X_Axis.renderer.inside = false;
            X_Axis.renderer.labels.template.fontSize = 10;
            // X_Axis.renderer.labels.template.disabled = true;
        }

        X_Axis.cursorTooltipEnabled = false;
        // X_Axis.renderer.top = true;
        if ("evenColor" in props.chart || "oddColor" in props.chart) {
            if (props.chart.evenColor || props.chart.evenColor) {
                var pattern = new am4core.LinePattern();
                pattern.width = 10;
                pattern.height = 10;
                pattern.strokeWidth = 1;
                pattern.stroke = am4core.color("#000000");
                pattern.rotation = 45;
                X_Axis.renderer.axisFills.template.disabled = false;
                X_Axis.renderer.axisFills.template.fill = pattern;
                X_Axis.renderer.axisFills.template.fillOpacity = 0.2;
                X_Axis.fillRule = function (dataItem) {
                    var date = new Date(dataItem.value);
                    if (date.getDate() % 2 === 0) {
                        dataItem.axisFill.visible = true;
                    }
                    else {
                        dataItem.axisFill.visible = false;
                    }
                }
            }
        }

        // Add cursor
        if ("zoom" in props.chart && !props.chart.zoom) {
        } else {
            chart.cursor = new am4charts.XYCursor();
        }
        // Add legend
        if ("legend" in props.chart && !props.chart.legend) {

        } else {
            chart.legend = new am4charts.Legend();
            chart.legend.position = "top";
            chart.legend.maxHeight = 80;
            chart.legend.marginBottom = 10;
            chart.legend.scrollable = true;

        }
        // Add scrollbar
        // chart.scrollbarX = new am4charts.XYChartScrollbar();
        if ("scrollbar" in props.chart && !props.chart.scrollbar) {

        } else {
            chart.scrollbarX = new am4core.Scrollbar();
            chart.scrollbarX.marginTop = 50
            chart.scrollbarX.parent = chart.bottomAxesContainer;
        }
        chart.padding(22, 22, 60, 0);
        // if (props.chart.axisX !== "date") {
        //   chart.scrollbarY = new am4core.Scrollbar();
        //   chart.scrollbarY.parent = chart.rightAxesContainer;
        //   chart.scrollbarY.dy = -10;
        // }
        // if ("legend" in props.chart) {
        //     if (props.chart.legend) {
        //         chart.legend = new am4charts.Legend();
        //         chart.legend.position = "top";
        //     }
        // } else {
        //     chart.legend = new am4charts.Legend();
        //     chart.legend.position = "top";
        // }

        if ("label_X" in props?.chart && !props.chart.label_X) {
            X_Axis.renderer.labels.template.disabled = true;
        }

        let valueAxis1 = [];
        if (props?.chart?.multipleValueAxes) {
            for (var index = 0; index < props.chart.series.length; index++) {
                let valueAxisRow = chart.yAxes.push(new am4charts.ValueAxis())
                if (chart.yAxes.indexOf(valueAxisRow) != 0) {
                    valueAxisRow.syncWithAxis = chart.yAxes.getIndex(0);
                }
                valueAxisRow.cursorTooltipEnabled = true;
                valueAxisRow.numberFormatter = new am4core.NumberFormatter();
                valueAxisRow.numberFormatter.numberFormat = "#  " + (props.chart.series[index]?.unit || "");
                const currentIndex = props.chart.series[index]
                if ("min" in props.chart || 'min' in currentIndex) {
                    valueAxisRow.min = ('min' in currentIndex)? (currentIndex.min): props.chart.min;
                } else {
                    valueAxisRow.min = 0;
                }
                if ("max" in props.chart || 'max' in currentIndex) {
                    // valueAxisRow.max = ('max' in currentIndex)? (currentIndex.max): props.chart.max;
                    valueAxisRow.max = 100
                }else{
                    valueAxisRow.max = 50
                }
                if ("grid" in props.chart && (!props.chart.grid || props.chart.grid === "x")) {
                    valueAxisRow.renderer.grid.template.stroke = "#00000000";
                }
                valueAxis1.push(valueAxisRow)
            }
        } else {
            if (!("valueAxis" in props.chart)) {
                valueAxis1 = [chart.yAxes.push(new am4charts.ValueAxis())];
                if (chart.yAxes.indexOf(valueAxis1[0]) != 0) {
                    valueAxis1[0].syncWithAxis = chart.yAxes.getIndex(0);
                }
                valueAxis1[0].cursorTooltipEnabled = false;
                valueAxis1[0].numberFormatter = new am4core.NumberFormatter();
                valueAxis1[0].numberFormatter.numberFormat = "#  " + (props.chart?.unit || "");
                if ("min" in props.chart) {
                    valueAxis1[0].min = props.chart.min;
                }
                if ("max" in props.chart) {
                    valueAxis1[0].max = props.chart.max;
                }
                valueAxis1[0].min = 0;
            }
            if ("label_Y" in props?.chart && !props.chart.label_Y) {
                valueAxis1[0].renderer.labels.template.disabled = true;
            }
            if ("grid" in props.chart && (!props.chart.grid || props.chart.grid === "x")) {
                valueAxis1[0].renderer.grid.template.stroke = "#00000000";
            }
        }
        // Add range
        if ("rangeLine" in props) {
            if (props.rangeLine) {
                let range = valueAxis1[0].axisRanges.create();
                range.value = props.rangeLine.value;
                let color = "color" in props.rangeLine ? props.rangeLine.color : props.graphcolor;
                if ("endValue" in props.rangeLine) {
                    range.endValue = props.rangeLine.endValue;
                    range.label.fill = am4core.color(color);
                    range.axisFill.fill = am4core.color(color);
                    range.axisFill.fillOpacity = 0.2;
                    range.grid.strokeOpacity = 0;
                } else {
                    range.grid.stroke = am4core.color(color);
                    range.grid.strokeWidth = 1;
                    range.grid.strokeOpacity = 1;
                    range.label.fill = range.grid.stroke;
                }
                range.label.inside = true;
                range.label.text = props.rangeLine.name;
                range.label.verticalCenter = "bottom";
                if ("value2" in props.rangeLine) {
                    let range2 = valueAxis1[0].axisRanges.create();
                    let color2 = "color" in props.rangeLine ? props.rangeLine.color2 : props.graphcolor;
                    range2.value = props.rangeLine.value2;
                    range2.grid.stroke = am4core.color(color2);
                    range2.grid.strokeWidth = 1;
                    range2.grid.strokeOpacity = 1;
                    range2.label.fill = range2.grid.stroke;
                    range2.label.inside = true;
                    range2.label.text = props.rangeLine.name2;
                    range2.label.verticalCenter = "bottom";
                }
            }
        }

        // chart.leftAxesContainer.layout = "vertical"
        if (props?.chart?.series?.length) {
            const serieseArray = props.chart.series.map((noSeries, key) => {
                let series;
                if (noSeries) {
                    let graphcolor;
                    if (!"color" in noSeries) {
                        if (key !== 0) {
                            graphcolor = rgbToHex(
                                Math.floor(Math.random() * 200 + 0),
                                Math.floor(Math.random() * 200 + 0),
                                Math.floor(Math.random() * 200 + 0)
                            );
                        }
                        if (colorArray.length) {
                            colorArray.map((color) => {
                                if (color === graphcolor) {
                                    graphcolor = rgbToHex(
                                        Math.floor(Math.random() * 200 + 0),
                                        Math.floor(Math.random() * 200 + 0),
                                        Math.floor(Math.random() * 200 + 0)
                                    );
                                    colorArray.push(graphcolor);
                                } else {
                                    colorArray.push(graphcolor);
                                }
                            });
                        } else {
                            colorArray.push(graphcolor);
                        }
                    } else {
                        graphcolor = noSeries.color;
                    }

                    let gradient = new am4core.LinearGradient();
                    gradient.addColor(am4core.color(graphcolor + "30"));
                    gradient.addColor(am4core.color(graphcolor + "30"));
                    let gradient2 = new am4core.LinearGradient();
                    gradient2.addColor(am4core.color(graphcolor));
                    gradient2.addColor(am4core.color(graphcolor));
                    let valueAxisLoop = null;
                    if ("seperatedValueAxis" in props.chart) {
                        if (props.chart.seperatedValueAxis) {
                            valueAxisLoop = chart.yAxes.push(new am4charts.ValueAxis());
                            if (chart.yAxes.indexOf(valueAxisLoop) != 0) {
                                valueAxisLoop.syncWithAxis = chart.yAxes.getIndex(0);
                            }
                            // valueAxisLoop.tooltip.disabled = true;
                            // valueAxisLoop.renderer.baseGrid.disabled = true;
                            valueAxisLoop.min = 0;
                            valueAxisLoop.title.text = noSeries.name;
                            valueAxisLoop.title.fontSize = 12;
                            valueAxisLoop.renderer.gridContainer.background.fill = interfaceColors.getFor("alternativeBackground");
                            valueAxisLoop.renderer.gridContainer.background.fillOpacity = 0.05;
                            valueAxisLoop.renderer.grid.template.stroke = interfaceColors.getFor("background");
                            valueAxisLoop.renderer.grid.template.strokeOpacity = 1;
                            valueAxisLoop.marginBottom = 20;
                        }
                    }

                    // if (noSeries.type === "binary") {
                    //     series = chart.series.push(new am4charts.StepLineSeries());
                    // } else if (noSeries.type === "bar") {
                    //     series = chart.series.push(new am4charts.ColumnSeries());
                    // } else if (noSeries.type === "pie") {
                    //     series = chart.series.push(new am4charts.PieSeries());
                    // } else {
                    //     series = chart.series.push(new am4charts.LineSeries());
                    //     // series.tensionX = 0.9;
                    //     series.smoothing = "monotoneX";
                    // }
                    if (noSeries.type === "binary") {
                        series = chart.series.push(new am4charts.StepLineSeries());
                    } else if (noSeries.type === "bar") {
                        series = chart.series.push(new am4charts.ColumnSeries());
                    } else if (noSeries.type === "bar-horizontal") {
                        series = chart.series.push(new am4charts.ColumnSeries());
                        series.columns.template.strokeOpacity = 0;
                        series.columns.template.column.cornerRadiusBottomRight = 5;
                        series.columns.template.column.cornerRadiusTopRight = 5;
                        series.interpolationDuration = 1000;
                        series.interpolationEasing = am4core.ease.linear;
                    } else if (noSeries.type === "pie") {
                        series = chart.series.push(new am4charts.PieSeries());
                    } else {
                        series = chart.series.push(new am4charts.LineSeries());
                        series.smoothing = "monotoneX";
                        // series.tensionX = "50px";
                    }
                    series.name = noSeries.name;
                    series.dataFields.valueY = noSeries.y;
                    if (props.chart.axisX === "date") {
                        series.dataFields.dateX = noSeries.x;
                        if ("seperatedValueAxis" in props.chart) {
                            if (props.chart.seperatedValueAxis) {
                                series.yAxis = valueAxisLoop;
                            } else {
                                if (props?.chart?.multipleValueAxes) {
                                    series.yAxis = valueAxis1[key];
                                } else {
                                    series.yAxis = valueAxis1[0];
                                }
                            }
                        } else {
                            if (props?.chart?.multipleValueAxes) {
                                series.yAxis = valueAxis1[key];
                            } else {
                                series.yAxis = valueAxis1[0];
                            }
                        }
                    } else if (props.chart.axisX === "category") {
                        series.dataFields.categoryX = "category";
                        if ("seperatedValueAxis" in props.chart) {
                            if (props.chart.seperatedValueAxis) {
                                series.yAxis = valueAxisLoop;
                            } else {
                                if (props?.chart?.multipleValueAxes) {
                                    series.yAxis = valueAxis1[key];
                                } else {
                                    series.yAxis = valueAxis1[0];
                                }
                            }
                        } else {
                            if (props?.chart?.multipleValueAxes) {
                                series.yAxis = valueAxis1[key];
                            } else {
                                series.yAxis = valueAxis1[0];
                            }
                        }
                        // series.xAxis = X_Axis;
                    }
                    series.stroke = am4core.color(graphcolor);
                    if ("tooltip" in props.chart && !props.chart.tooltip) {
                        series.tooltip.disabled = true;
                    } else {
                        let isGroupTooltip = false
                        if ("tooltipGroup" in props.chart) {
                            if (props.chart.tooltipGroup) {
                                isGroupTooltip = true
                            }
                        }
                        if (!isGroupTooltip) {
                            if ('customTooltip' in noSeries) {
                                series.tooltipText = noSeries.customTooltip
                            } else
                                if (props.chart.axisX === "date") {
                                    let unit = "";
                                    if ("unit" in props.chart) {
                                        unit = props.chart.unit
                                    }
                                    series.tooltipText = "{name}\n[bold font-size: 20]{valueY}[/]" + unit + "\n{dateX}";
                                } else {
                                    let unit = "";
                                    if ("unit" in props.chart) {
                                        unit = props.chart.unit
                                    }
                                    series.tooltipText = "{name}\n[bold font-size: 20]{valueY}[/] " + unit;
                                    if ("onSelectedColumns" in props) {
                                        series.columns.template.events.on(
                                            "hit",
                                            columnEventListner,
                                            this
                                        );
                                    }
                                }
                        } else {
                            let unit = "";
                            if ("unit" in props.chart) {
                                unit = props.chart.unit
                            }
                            for (const list of props.chart.tooltipGroup) {
                                if (noSeries.y === list.showOn) {
                                    let infoText = ""
                                    for (const [key, seriesName] of list.showList.entries()) {
                                        infoText += seriesName + ": [bold font-size: 20]{" + seriesName + "}"
                                        if (key < list.showList.length - 1) {
                                            infoText += "[/]" + unit + "\n"
                                        }
                                    }
                                    series.tooltipText = infoText;
                                    // series.tooltipText = " {name}: [bold font-size: 20]{valueY}[/]" + unit + "\n{dateX}";
                                }
                            }
                        }
                        series.tooltip.zIndex = Infinity;
                        series.tooltip.label.getFillFromObject = true;
                        series.tooltip.label.background.fill = am4core.color(graphcolor);

                        if (props.chart.axisX === "date") {
                            let bullet = series.bullets.push(new am4charts.CircleBullet());
                            bullet.circle.radius = 3;
                            bullet.circle.strokeWidth = 2;
                            bullet.circle.fill = am4core.color("#fff");
                            if ("onSelectedColumns" in props) {
                                series.columns.template.events.on(
                                    "hit",
                                    columnEventListner,
                                    this
                                );
                                bullet.events.on("hit", columnEventListner, this);
                            }
                        } else {
                            if ('showCategoryOnly' in props.chart && props.chart.showCategoryOnly) {
                                let bullet = series.bullets.push(new am4charts.CircleBullet());
                                bullet.circle.radius = 3;
                                bullet.circle.strokeWidth = 2;
                                bullet.circle.fill = am4core.color("#fff");
                            } else {
                                var bullet = series.bullets.push(new am4charts.LabelBullet());
                                let unit = "";
                                if ("unit" in props.chart) {
                                    unit = props.chart.unit
                                }
                                bullet.label.text = "{valueY} " + unit;
                                bullet.label.rotation = -90;
                                bullet.label.truncate = false;
                                bullet.label.hideOversized = false;
                                bullet.label.horizontalCenter = "left";
                                bullet.label.fontSize = 10;
                                bullet.locationY = 1;
                                bullet.dy = -10;
                            }

                            if ("onSelectedColumns" in props) {
                                bullet.events.on("hit", columnEventListner, this);
                            }
                            // chart.maskBullets = false;
                        }
                    }

                    if ("fill" in props.chart && !(props?.chart?.fill)) {
                        series.fillOpacity = 0
                    } else {
                        series.fillOpacity = 1
                    }
                    if ("stroke" in props.chart && !(props?.chart?.stroke)) {
                        series.strokeWidth = 0
                        series.fill = gradient2;
                    } else {
                        series.strokeWidth = 2
                        series.fill = gradient;
                    }
                    if (key === 0) {
                        // series = series;
                        series1.current = series;
                    }


                    if ("seriesRange" in noSeries) {
                        noSeries.seriesRange.map(rangeConfig => {
                            let range = valueAxis1[0].createSeriesRange(series);
                            const rangeColor = am4core.color(rangeConfig?.strokeColor || "#FF0000");
                            range.value = rangeConfig?.value || 0;
                            range.endValue = rangeConfig?.endValue || -1000;
                            range.contents.stroke = rangeColor;
                            if (rangeConfig?.rangeLine) {
                                let range1 = valueAxis1[0].axisRanges.create()
                                range1.grid.stroke = rangeColor;
                                range1.value = rangeConfig?.value || 0;;
                                range1.grid.strokeWidth = 1;
                                range1.grid.strokeDasharray = "2,3";
                                range1.grid.strokeOpacity = 1;
                                if (rangeConfig?.rangeLineLabel) {
                                    range1.label.fill = rangeColor;
                                    range1.label.inside = true;
                                    range1.label.text = (rangeConfig?.prefix || "") + range1.value + (rangeConfig?.suffix || "");
                                    range1.label.fontSize = 13;
                                    range1.label.paddingTop = (
                                        rangeConfig.labelVerticalAlign === 'top' ?
                                            0
                                            : rangeConfig.labelVerticalAlign === 'middle' ?
                                                10
                                                : rangeConfig.labelVerticalAlign === 'bottom' ?
                                                    25
                                                    : 0
                                    ) || 0;

                                    // range1.label.verticalCenter = rangeConfig?.labelVerticalAlign || "center";
                                    range1.label.align = rangeConfig?.labelAlign || "right";
                                }
                            }
                        })
                    }
                    if ("limitRange" in props) {
                        let range1 = valueAxis1[0].axisRanges.create()
                        range1.grid.stroke = am4core.color("#FF0000");
                        range1.value = 10;
                        range1.grid.strokeWidth = 1;
                        range1.grid.strokeDasharray = "2,3";
                        range1.grid.strokeOpacity = 1;
                        range1.label.fill = am4core.color("#FF0000");
                        range1.label.inside = true;
                        range1.label.text = "asd";
                        range1.label.fontSize = 13;
                        range1.label.verticalCenter = "bottom";
                        range1.label.align = "right";
                    }


                    if (props?.chart?.multipleValueAxes && (key % 2 === 1)) {
                        valueAxis1[key].renderer.opposite = true;
                    }
                    if ("opposite" in noSeries) {
                        valueAxis1[0].renderer.opposite = noSeries.opposite;
                    }

                    return series
                }

            }).filter(e => e !== undefined && e !== null);
            if (serieseArray.length > 3) {
                const toggleSeries = chart.series.push(new am4charts.LineSeries())
                toggleSeries.dataFields.valueY = 'void';
                if (props.chart.axisX === "category") {
                    toggleSeries.dataFields.categoryX = "category";
                } else {
                    toggleSeries.dataFields.dateX = "date";
                }
                toggleSeries.name = 'Show All';
                toggleSeries.events.on("hidden", function () {
                    toggleSeries.name = 'Show All'
                    for (const ser of serieseArray) {
                        ser.hide();
                    }
                });
                toggleSeries.events.on("shown", function () {
                    toggleSeries.name = 'Hide All'
                    for (const ser of serieseArray) {
                        ser.show();
                    }
                });
            }
            if (serieseArray.length > 3) {
                chart.cursor.maxTooltipDistance = -1;
            }
        }
        X_Axis.renderer.labels.template.adapter.add(
            "rotation",
            function (rotation, target) {
                let dataItem = target.dataItem;

                // if (
                //     dataItem.date &&
                //     dataItem.date.getTime() ==
                //     am4core.time
                //         .round(new Date(dataItem.date.getTime()), "hour")
                //         .getTime()
                // ) {
                //     target.verticalCenter = "middle";
                //     target.horizontalCenter = "left";
                //     return -90;
                // } else if (dataItem.category) {
                //     target.verticalCenter = "bottom";
                //     target.horizontalCenter = "left";
                //     return -90;
                // }
                // else {
                //     target.verticalCenter = "bottom";
                //     target.horizontalCenter = "middle";
                //     return 0;
                // }
                target.verticalCenter = "top";
                target.horizontalCenter = "middle";
                return 0;
            }
        );

        if ("export" in props.chart) {
            if (props.chart.export) {
                chart.exporting.menu = new am4core.ExportMenu();
                // am4core.color("#f00")
                chart.exporting.menu.items = [{
                    "label": "Export",
                    "menu": [
                        { "label": "EXCEL", "type": "csv" },
                        { "type": "pdf", "label": "PDF" },
                        // { "type": "png", "label": "PNG" },
                    ]
                }];
                // chart.exporting.items.color = ""
                // chart.exporting.menu.items.color = "blue"
                chart.exporting.menu.container = document.getElementById(props.chart.id + "-btn");
                // chart.exporting.menu.items[0].icon = "data:image/png;base64,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" ;
                // chart.exporting.menu.items[0].label = "Export";
                chart.exporting.filePrefix = "Export" + " " + new Date();
                chart.exporting.pageOrigin = false;
                // chart.exporting.getFormatOptions("csv").pivot = false;
            }
        }
        // if ("scrollbar" in props.chart && !props.chart.scrollbar) {
        //     chart.padding(0, 0, 22, 0);
        // } else {
        //     // Add scrollbar
        //     chart.scrollbarX = new am4charts.XYChartScrollbar();
        //     chart.scrollbarX.parent = chart.bottomAxesContainer;
        //     let scrollAxis = chart.scrollbarX.scrollbarChart.xAxes.getIndex(0);
        // }

        chart1.current = chart
    };
    const columnEventListner = (e) => {
        props.onSelectedColumns(e.target.dataItem.dataContext);
    };
    const componentToHex = (c) => {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    };

    const rgbToHex = (r, g, b) => {
        return (
            "#" +
            componentToHex(r) +
            componentToHex(g) +
            componentToHex(b)
        );
    };
    const primaryColor = () => {
        if ("graphcolor" in props) {
            var color = props.graphcolor;
            let gradient = new am4core.LinearGradient();
            gradient.addColor(am4core.color(color + "15"));
            gradient.addColor(am4core.color(color + "15"));

            series1.current.stroke = am4core.color(color);
            series1.current.tooltip.label.background.fill = am4core.color(color);
            series1.current.fill = gradient;
        }
    };
    return (
        <div className="chartOuter" style={"height" in props ? { height: props.height } : null}>

            {("export" in props.chart) ?
                (props.chart.export) ?
                    <div id={props.chart.id + "-btn"} style={{
                        padding: "0.5em 1em",
                        position: "relative",
                        minHeight: "27px",
                        zIndex: 1
                    }}></div>
                    : null : null}
            <div className="chartInner"
                id={props.chart.id}
                style={{
                    width: "100%",
                    height:
                        // props.chart.scrollbar === true
                        // ?
                        ("export" in props.chart) ?
                            (props.chart.export) ?
                                "calc(100% - 8px)"
                                : "calc(100% + 20px)"
                            : "calc(100% + 20px)"
                    // : "calc(100% + 70px)",
                }}
            ></div>
        </div>
    );

}
)
export default ChartConfig